export const identityInitialState = {
	usersList: [],
	isUserListLoading: true,
	isNewUserLoading: false,
	securityData: {},
	isSecurityDataLoading: true,
	isTwoFactorEnableLoading: false,
	isCodeVerificationLoading: false,
	isVerificationLoginCodeLoading: false,
	isRemovingTwoFactorAuthLoading: false,
	isChangePasswordLoading: false,
	usersListPaginationTokens: [],
	hasUserNextPage: false,
	userData: null,
	isUserDataLoading: false,
	accountManagerList: [],
	isAccountManagerListLoading: false,
	isResendInvitationLoading: false,
};
